import { styled, css } from '../../components-v4/theme';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.base};
    position: relative;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    gap: ${theme.spacings.base};
    background-color: ${theme.colors.gray[50]};
    overflow-y: auto;
    scrollbar-gutter: stable;

    ${theme.tokens.media.tablet} {
      padding-inline: ${theme.spacings.l};
    }

    & > .inner-block {
      margin: 0 auto;
      width: 704px;
      max-width: 100%;

      ${theme.tokens.media.down('desktop')} {
        width: 100%;
        max-width: 100%;
      }
    }
  `}
`;
